module.exports = __webpack_public_path__ + "img/ic_manage2.d0e99e2d.png";